import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/apps/page.tsx")